var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 192 192",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#F09A0FFF",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("g", { attrs: { fill: "none" } }, [
          _c("path", {
            staticStyle: {
              fill: "#f09a0fff",
              "fill-opacity": "0",
              stroke: "#f09a0fff",
              "stroke-width": "12",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "6",
              "stroke-dasharray": "none",
              "stroke-opacity": "1",
            },
            attrs: {
              d: "M43.516 108.672a64.034 55.026 0 0 1 9.856-72.646 64.034 55.026 0 0 1 85.111-.064 64.034 55.026 0 0 1 10.004 72.631 64.034 55.026 0 0 1-82.777 17.012",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: {
              fill: "#f09a0fff",
              "fill-opacity": "0",
              stroke: "#f09a0fff",
              "stroke-width": "12",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-opacity": "1",
              "paint-order": "stroke fill markers",
            },
            attrs: { d: "m43.502 108.845-6.065 25.465 28.128-8.73" },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: {
              fill: "#f09a0fff",
              "fill-opacity": "0",
              stroke: "#f09a0fff",
              "stroke-width": "8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "6",
              "stroke-dasharray": "none",
              "stroke-opacity": "1",
              "paint-order": "stroke fill markers",
            },
            attrs: {
              d: "M81.976 63.588A14.588 14.588 0 0 1 96.564 49a14.588 14.588 0 0 1 14.587 14.588m-29.158-.198v11.596m29.172-11.42.056 11.003",
            },
          }),
          _vm._v(" "),
          _c("ellipse", {
            staticStyle: {
              fill: "#f09a0fff",
              "fill-opacity": "0",
              stroke: "#f09a0fff",
              "stroke-width": "8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "6",
              "stroke-dasharray": "none",
              "stroke-opacity": "1",
              "paint-order": "stroke fill markers",
            },
            attrs: { cx: "54.659", cy: "162.498", rx: "9.323", ry: "9.502" },
          }),
          _vm._v(" "),
          _c("ellipse", {
            staticStyle: {
              fill: "#f09a0fff",
              "fill-opacity": "0",
              stroke: "#f09a0fff",
              "stroke-width": "8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "6",
              "stroke-dasharray": "none",
              "stroke-opacity": "1",
              "paint-order": "stroke fill markers",
            },
            attrs: { cx: "95.592", cy: "162.498", rx: "9.323", ry: "9.502" },
          }),
          _vm._v(" "),
          _c("ellipse", {
            staticStyle: {
              fill: "#f09a0fff",
              "fill-opacity": "0",
              stroke: "#f09a0fff",
              "stroke-width": "8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "6",
              "stroke-dasharray": "none",
              "stroke-opacity": "1",
              "paint-order": "stroke fill markers",
            },
            attrs: { cx: "137.185", cy: "162.498", rx: "9.323", ry: "9.502" },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: {
              fill: "#f09a0fff",
              "fill-opacity": "0",
              stroke: "#f09a0fff",
              "stroke-width": "8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-miterlimit": "6",
              "paint-order": "stroke fill markers",
            },
            attrs: { d: "M116.14 76.146v25.459H76.998V76.146h39.052" },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }